module.exports = __webpack_public_path__ + "img/gpm.fa0cfad0.png";